// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XqE9Z","btn":"Footer_btn__rF35m","btn_active":"Footer_btn_active__RdN8b"};